import React from 'react'
import Pagination from 'react-bootstrap/Pagination'
import EmployeeLeavePlanTable from './EmployeeLeavePlanTable'
import GenericPagination from '../../shared/GenericPagination'
import Modal from '../../shared/Modal'

class EmployeeLeavePlans extends React.Component {
  constructor (props) {
    super (props)

    this.state = {
        modal: {
          show: false,
          confirmationType: '',
          id: ''
        }
    }
  }

  shouldComponentUpdate(nextProps,nextState){
    if(this.props.leavePlans === nextProps.leavePlans && this.state === nextState){return false;}
    else return true;
  }

  changePageNumber (pageNumber) {
    this.props.currentPageNumber(this.props.type, pageNumber)
  }

  showConfirmation (leave_plan_id, confirmationType) {
    const modal = {
      ...this.state.modal,
      ...{
        show: true,
        confirmationType: confirmationType,
        id: leave_plan_id
      }
    }

    this.setState({
      modal
    })
  }

  showModal () {
    if (this.state.modal.show) {
      return (
        <Modal
          {...this.state.modal}
          hideModalInParent={this.hideModal.bind(this)}
          id={this.state.modal.id}
          approve={this.confirmationApproval()} >
          <span>{ this.confirmationMessage() }</span>
        </Modal>
      )
    }
  }

  hideModal () {
    const modal = {
      ...this.state.modal,
      ...{
        show: false,
        confirmationType: '',
        id: null
      }
    }
    this.setState({
      modal
    })
  }

  confirmationMessage () {
    if (this.state.modal.confirmationType === 'switch') {
      return 'Are you sure you want to switch leave plan ?'
    } else if (this.state.modal.confirmationType === 'archive') {
      return 'Are you sure you want to archive it ?'
    } else if (this.state.modal.confirmationType === 'delete') {
      return 'Are you sure you want to delete it ?'
    } else if (this.state.modal.confirmationType === 'reactivate') {
      return 'Are you sure you want to reactivate it?'
    } else {
      return ''
    }
  }

  archive_leave_plan (leave_plan_id) {
    this.props.archiveLeavePlan(this.props.type, leave_plan_id)
  }

  switch_leave_plan (leave_plan_id) {
    this.props.switchLeavePlan(leave_plan_id)
  }

  delete_leave_plan (leave_plan_id) {
    this.props.removeLeavePlan(this.props.type, leave_plan_id)
  }

  reactivate_leave_plan (leave_plan_id) {
    this.props.reactivateLeavePlan(leave_plan_id)
  }

  confirmationApproval () {
    if (this.state.modal.confirmationType === 'switch') {
      return this.switch_leave_plan.bind(this)
    } else if (this.state.modal.confirmationType === 'archive') {
      return this.archive_leave_plan.bind(this)
    } else if (this.state.modal.confirmationType === 'delete') {
      return this.delete_leave_plan.bind(this)
    } else if (this.state.modal.confirmationType === 'reactivate') {
      return this.reactivate_leave_plan.bind(this)
    }
  }

  render () {
    let { leave_plans, leave_plans_count, currentPage, options} = this.props.leavePlans
    let title = this.props.type == 'active' ? 'Other Active Leaveplans' : 'Other Archived Leaveplans'

    return (
      <div>
        <div className='row'>
          <div className='col-md-4'>
           <h3>{title}</h3>
          </div>
          <div className='col-md-6'>
            <GenericPagination
              itemsPerPage={5}
              totalItems={leave_plans_count}
              currentPage={currentPage}
              changePageNumber={this.changePageNumber.bind(this)}
            />
          </div>
        </div>
        <div className='row'>
          <div className='manage-leave-plans'>
            <EmployeeLeavePlanTable
              leavePlans={leave_plans}
              options={options}
              showConfirmation={this.showConfirmation.bind(this)}
            />
            </div>
        </div>
        { this.showModal() }
      </div>
    )
  }
}

export default EmployeeLeavePlans;
